const baseUrl = {
  development: {
    wxDomain: '//test-gateway.jinyi999.cn/rjhy-wechat-platform',
    wechatDomain: '//test-gateway.jinyi999.cn/rjhy-promotion-wechat',
    promotionDomain: '//test-gateway.jinyi999.cn/rjhy-promotion',
    smsDomain: '//test-gateway.jinyi999.cn/rjhy-sms',
    userDomain: '//test-gateway.jinyi999.cn/rjhy-user',
    vasterDomain: 'https://test-gateway.jinyi999.cn/rjhy-vaster-mgr',
    dynamicDomain: '//test-gateway.jinyi999.cn/rjhy-dynamic',
    resourceDoamin: '//test-gateway.jinyi999.cn/rjhy-promotion-resource',
    moonDoamin: '//test-gateway.jinyi999.cn/rjhy-promotion-moon',
    adDomain: '//test-gateway.jinyi999.cn/rjhy-ad',
  },
  production: {
    wxDomain: '//gateway.techgp.cn/rjhy-wechat-platform',
    wechatDomain: '//gateway.techgp.cn/rjhy-promotion-wechat',
    promotionDomain: '//gateway.techgp.cn/rjhy-promotion',
    smsDomain: '//gateway.techgp.cn/rjhy-sms',
    userDomain: '//gateway.techgp.cn/rjhy-user',
    vasterDomain: '//gateway.techgp.cn/rjhy-vaster-mgr',
    dynamicDomain: '//gateway.techgp.cn/rjhy-dynamic',
    resourceDoamin: '//gateway.techgp.cn/rjhy-promotion-resource',
    moonDoamin: '//gateway.techgp.cn/rjhy-promotion-moon',
    adDomain: '//gateway.chongnengjihua.com/rjhy-ad',
  }
}

const baseDomain = baseUrl[process.env.NODE_ENV]
const qlSecureDomain = process.env.VUE_APP_QL_SECURE_DOMAIN

const requestUrl = {
  GET_MINI_LINK: `${baseDomain.wxDomain}/api/platform/url/scheme/get`,
  SEND_MSG_API: `${baseDomain.smsDomain}/api/1/web/captcha/sms/freesend`,
  LOGIN: `${baseDomain.userDomain}/api/3/user/web/sms/login`,
  GET_QRCODE: `${baseDomain.vasterDomain}/pageLink/getStaffRandom`,
  GET_PUBLIC_OFFICIAL_INFO: `${baseDomain.dynamicDomain}/api/1/config/analysis`,
  GET_USER_BY_TOKEN: `${baseDomain.userDomain}/api/1/user/htzwechat/info`,
  GET_USER_BY_CODE: `${baseDomain.wxDomain}/api/platform/auth/web/token/code2`,
  GET_MASK_USER_INFO: `//${qlSecureDomain}/rjhy-user/api/1/web/user/gw/info`,
  QUERY_USER_CROWD: `${baseDomain.moonDoamin}/api/1/ad/queryUserCrowd`,
  GET_WX_LINK: `${baseDomain.wechatDomain}/api/v1/wechat/kf/getLink`,
  UC_RETURN: `${baseDomain.promotionDomain}/api/v1/activateByConfig/UCH5`,
  MP_RETURN: `${baseDomain.promotionDomain}/api/v1/activateByConfig/wechatMP`,
  GDT_RETURN: `${baseDomain.promotionDomain}/api/v1/activateByConfig/tengXunGDT`,
  TOUTIAO_RETURN: `${baseDomain.promotionDomain}/api/v1/activateByConfig/byteDanceH5`,
  BAIDU_RETURN: `${baseDomain.promotionDomain}/api/v1/activateByConfig/baidu`,
  PC_360_RETURN: `${baseDomain.promotionDomain}/api/v1/activateByConfig/qh360/pc`,
  KUAISHOU_RETURN: `${baseDomain.promotionDomain}/api/v1/activateByConfig/quickHandH5`,
  WEIBO_RETURN: `${baseDomain.promotionDomain}/api/v1/activateByConfig/weiBo/submitFrom`,
  ADD_FRIEND_FRONT: `${baseDomain.promotionDomain}/api/v1/add/friend/notify`,
  QUERY_PEER: `${baseDomain.resourceDoamin}/api/v1/promotion/resource/blackAndPeer/query`,
  COMMON_RESOURCE: `${baseDomain.resourceDoamin}/api/v1/common/resource`,  // 通用防重复接口
  GET_MINI_IMAGE_URL: `${baseDomain.resourceDoamin}/api/v1/get/mini/imageUrl`,
  CORP_ADD_REPEAT_NEW: `${baseDomain.resourceDoamin}/api/v1/corp/add/repeat/new`,
  FETCH_PAGE_INFO: `${baseDomain.vasterDomain}/pageLink/getPageLinkDetail`,  // 通用防重复接口
  VASTER_BANNER: `${baseDomain.moonDoamin}/api/1/moon/promotion/page/config/pageCode`,  //vaster获取配置
  POST_AD_VASTER: `${baseDomain.adDomain}/api/1/xcx/ad/query/list`,  //广告查询接口
}

export default requestUrl
